module.exports = __webpack_public_path__ + "img/facs_thumb.c6ed767d.png";